import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../../yeffect/StateProvider';
import {API, BASE_URL} from "../../../../config";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {connect} from "react-redux";

import {Button, Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Paper} from "@material-ui/core";
import TextInput from "../../../../yeffect/formBuilder/components/TextInput";
import InputRow from "../../../../yeffect/formBuilder/components/InputRow";
import RadioInput from "../../../../yeffect/formBuilder/components/RadioInput";
import CheckBoxInput from "../../../../yeffect/formBuilder/components/CheckboxInput";
import SelectInput from "../../../../yeffect/formBuilder/components/SelectInput";

import Document from "../../isinApplications/components/UploadDocument";
import Util from "../../../../yeffect/utils";
import CountrySelect from "../../../../yeffect/formBuilder/components/CountrySelect";

import _ from "lodash";

const fileRequests = API.service('file-request');
const uploadedFiles = API.service('uploaded-files');

const permanentFields = [
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Description', fieldName:'description'},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-full',fieldLabel:'Active', fieldName:'active', required:true,
        possibleValues:[{value:'','label':'-'}, {value:1,'label':'Active'}, {value:0,'label':'In Active'}]},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Request Type', fieldName:'type'},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-full',fieldLabel:'Number of Files', fieldName:'multifile', required:true,
        possibleValues:[{value:'','label':'-'}, {value:0,'label':'Single File'}, {value:1,'label':'Multiple Files'}]},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Expiry', fieldName:'expiry', helperText:"Date Only in Format YYYY-MM-DD"}
]

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    detail:{
        height:'100%',
        overflow:'auto'
    },
    detailContent:{
        margin:'8px 0',
        paddingTop:'10px'
    },
    tabs:{
        display:'inline-block',
        width:'100%',
        borderBottom:'2px solid #6a94ff',
        marginLeft:0,
        paddingLeft:0,

        '& li':{
            display:'inline-block',

            '& button':{
                margin:'1px',
                padding:'6px 12px',
                backgroundColor:'#383c42',
                color:'white'
            },
            '& button:hover':{
                backgroundColor:'#6a94ff',
            },
            '& button.active':{
                backgroundColor:'#6a94ff',
            }
        }
    },
    flex: {
        flex: 1,
    },

});

class OpenIsin extends Component {
    state={
        activeTab:'form',
        formResults: (typeof this.props.fileRequest.request_uuid === 'undefined') ? {
            request_uuid: Util.uuid(),
        } : JSON.parse(JSON.stringify(this.props.fileRequest)),
        debug: false,
        docIds : [],
        errors:{},
    }

    closeDetails = () => {
        this.props.context.update({
            drawerContent:false,
            drawerWidth:null
        })
    }

    componentDidMount() {
        const app = this;

        uploadedFiles.find({query:{request_id:this.state.formResults['request_uuid']}}).then(x=> {

            app.setState({
                permanentFields: this.buildForm(permanentFields),
                docIds: x.data,
            }, () => console.log(this.state["formDefinition" + 1]));
        })
    }

    fieldContent = (formRow) =>{
        if(formRow.type==='InputRow'){
            return (<InputRow>
                    {formRow.children.map((v,i)=>{
                        return this.fieldContent(v)
                    })}
                </InputRow>
            )
        };

        if(formRow.type==='textinput'){
            return (<TextInput fieldLabel={formRow.fieldLabel} width={formRow.width} onChange={this.updateFormContent} value={this.state.formResults[formRow.fieldName] } fieldName={formRow.fieldName} required={(formRow.required)} errorFields={this.state.errors} helperText={formRow.helperText}/>)
        }

        if(formRow.type==='radioinput'){
            return (<RadioInput fieldLabel={formRow.fieldLabel} width={formRow.width} possibleValues={formRow.possibleValues} fieldName={formRow.fieldName} onChange={this.updateFormContent} /> )
        }

        if(formRow.type==='checkinput'){
            return (<CheckBoxInput fieldLabel={formRow.fieldLabel} width={formRow.width} onChange={this.updateFormContent} fieldName={formRow.fieldName} value={this.state.formResults[formRow.fieldName]} />)
        }

        if(formRow.type==='selectinput'){
            return (<SelectInput fieldLabel={formRow.fieldLabel} width={formRow.width} possibleValues={formRow.possibleValues} value={this.state.formResults[formRow.fieldName] } onChange={this.updateFormContent} required={(formRow.required)} fieldName={formRow.fieldName} errorFields={this.state.errors} />)
        }

        if(formRow.type==='countryselect'){
            return (<CountrySelect fieldLabel={formRow.fieldLabel} width={formRow.width} value={this.state.formResults[formRow.fieldName] } onChange={this.updateFormContent} required={(formRow.required)} fieldName={formRow.fieldName} errorFields={this.state.errors} />)
        }

        if(formRow.type==='sectionHeading'){
            return (<h3>{formRow.fieldLabel}</h3>)
        }
    }

    buildForm(formDefinition){
        let rowOpen = false;
        let compiled = []
        formDefinition.forEach((v,i)=>{
            if(v.type==='InputRow'){
                if(rowOpen !== false){
                    compiled.push(formDefinition[rowOpen])
                    rowOpen = i;
                    formDefinition[i].children=[];
                } else {
                    rowOpen = i;
                    formDefinition[i].children=[];
                }
            } else {
                if(rowOpen !== false) {
                    formDefinition[rowOpen].children.push(v)
                } else {
                    compiled.push(v)
                }
            }
        })
        if(rowOpen !== false){
            compiled.push(formDefinition[rowOpen])
        }
        return compiled;
    }

    fieldValidation(method, value) {
        if(method === 'email'){
            return (Util.validateEmail(value)) ? true : "Please enter a valid email address."
        }

        if(method === 'number'){
            return (Util.validateNumber(value)) ? true : "Please only enter numbers."
        }
    }

    changeTab = (e, variable, value=null) => {
        if(value === null){
            value = e.target.id;
        }
        this.setState(_.set({ ...this.state, error: '' }, variable, value));

        /*this.setState({
        //    activeTab:e.target.id
        })*/
    }

    validateStage = () => {
        let form = [];
        let errors = {};
        if(this.state.stage === 'issuer'){
            //form = (this.props.match.params.type === "equity") ? formBuilder : formBuilderdebt;
        }
        if(this.state.stage === 'issue'){
            //form = (this.props.match.params.type === "equity") ? formBuilder2 : formBuilder2debt;
        }
        if(this.state.stage === 'requestor'){
            //form = formBuilder3
        }
        if(this.state.stage === 'billing'){
            //form = formBuilder4
        }

        if(form.length !== 0) {
            form.forEach((v, i) => {
                if (typeof v.validate !== "undefined" && (Util.isEmpty(this.state.formResults[v.fieldName]) === false) ){
                    let result = this.fieldValidation(v.validate, this.state.formResults[v.fieldName])
                    if(result !== true){
                        errors[v.fieldName] = result;
                    }
                }

                if (v.required === true && Util.isEmpty(this.state.formResults[v.fieldName])) {
                    errors[v.fieldName] = "Please enter a value for " + v.fieldLabel;
                }

            })
        }

        this.setState({
            errors:errors
        })

        return (Object.keys(errors).length === 0)
    };

    updateInbound = (doc_id) => {
        console.log(doc_id)
        let docs = this.state.docIds;
        docs.push(doc_id);
        this.setState({
            docIds:docs,
        })
    }

    prepareAdminEmail = () => {
        let content = "<h4>Issuer Information</h4>";
        //content += this.buildEmail(this.state.formResults.application_type === "equity" ? formBuilder : formBuilderdebt);
        return content;
    }

    buildEmail(formDefinition){
        let compiled = "";
        formDefinition.forEach((v,i)=>{
            compiled += this.emailContent(v)
        })

        return compiled + "<br /><br />";
    }

    emailContent = (formRow) =>{
        if(formRow.type==='textinput'){
            return "<b>" + formRow.fieldLabel + ":</b> " + ((typeof this.state.formResults[formRow.fieldName] !== "undefined") ? this.state.formResults[formRow.fieldName] : "" )+ "<br />";
        }

        if(formRow.type==='radioinput'){
            return "<b>" + formRow.fieldLabel + ":</b> " + ((typeof this.state.formResults[formRow.fieldName] !== "undefined") ? this.state.formResults[formRow.fieldName] : "" ) + "<br />";
        }

        if(formRow.type==='checkinput'){
            return "<b>" + formRow.fieldLabel + ":</b> " + ((typeof this.state.formResults[formRow.fieldName] !== "undefined") ? this.state.formResults[formRow.fieldName] : "" ) + "<br />";
        }


        if(formRow.type==='selectinput'){
            let content = "<b>" + formRow.fieldLabel + ":</b> ";
            formRow.possibleValues.forEach(v=>{
                if (v.value === this.state.formResults[formRow.fieldName]){
                    content = content + v.label;
                }
            });

            return content + "<br />";
        }

        return "";
    }

    submitForm = (successCallback) => {
        if(typeof this.state.formResults.id === 'undefined') {
            fileRequests.create(this.state.formResults).then(r => {
                this.setState({
                    alertContent: 'Record Created',
                    alertType: 'success'
                })
                successCallback();
            }).catch(e => {
                console.log(e);
                this.setState({
                    alertContent: 'Error Found',
                    alertType: 'error'
                })
            })
        } else {
            fileRequests.update(this.state.formResults.id, this.state.formResults).then(r => {
                this.setState({
                    alertContent: 'Record Saved',
                    alertType: 'success'
                })
                successCallback();
            }).catch(e => {
                console.log(e);
                this.setState({
                    alertContent: 'Error Found',
                    alertType: 'error'
                })
            })
        }
    }

    updateFormContent = (event) =>{
        let currentForm = this.state.formResults;
        currentForm[event.target.name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({formResults: currentForm });
    }

    render() {
        const {classes} = this.props;

        return (
            <div className={classes.detail + ' flex flex-col'} style={{height:'100vh'}}>
                <AppBar position="static">
                    <Toolbar>
                        <div className={classes.flex}>
                            <Typography variant="title" color="inherit">
                                {(typeof this.state.formResults.description !== "undefined") &&
                                    <span style={{textTransform: 'capitalize'}}>{this.state.formResults.description}</span>
                                }
                                {(typeof this.state.formResults.description === "undefined") &&
                                    <span style={{textTransform: 'capitalize'}}>New File Request</span>
                                }
                            </Typography>
                            <Typography variant="subheading" color="inherit">
                                {(typeof this.state.formResults.isin !== "undefined") &&
                                    <span>{this.state.formResults.isin}</span>
                                }
                            </Typography>
                        </div>
                        <Button variant={'contained'} color={'secondary'} onClick={()=>this.submitForm(this.props.closeDrawer)}>Save </Button> &nbsp;&nbsp;&nbsp;
                        <IconButton onClick={this.props.closeDrawer} color={'inherit'}><Icon>clear</Icon></IconButton>
                    </Toolbar>
                </AppBar>

                <div style={{padding:20,paddingBottom:0,paddingTop:0}}>

                    <div className={classes.detailContent}>
                        <ul className={classes.tabs}>
                            <li>
                                <button className={(this.state.activeTab === 'form') ? 'active' : ''}
                                        style={{textTransform: 'capitalize'}}
                                        onClick={(e)=>this.changeTab(e,'activeTab')} id={'form'}>{this.state.application_type} Issuer
                                </button>
                            </li>
                            <li>
                                <button className={(this.state.activeTab === 'files') ? 'active' : ''}
                                        onClick={(e)=>this.changeTab(e,'activeTab')} id={'files'}>File Uploads
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={'flex-1'} style={{overflow:'auto',padding:20,paddingTop:0}}>
                    {(this.state.activeTab === 'form' && this.state.permanentFields) &&
                        <React.Fragment>
                            {this.state.permanentFields.map((v, i) => {
                                return this.fieldContent(v, this.state.formResults);
                            })}

                            <div className={'pt-24'}>
                                Once saved this request can be included in an email by sending the following link to the requestee.
                            </div>
                            <div className={'pt-12'}>
                                {BASE_URL}/upload_file_request/{this.state.formResults.request_uuid}
                            </div>
                        </React.Fragment>
                    }

                    {(this.state.activeTab === 'files') &&
                    <React.Fragment>

                        <Paper style={{width:'50%', marginLeft:'25%',padding:30,textAlign:'center'}}>
                            <AppBar position="static" elevation={0} color={"default"}>
                                <Toolbar>
                                    <div className={classes.flex}>
                                        <Typography variant="title" color="inherit">
                                            Uploaded Documents:
                                        </Typography>
                                    </div>
                                    <div style={{marginTop:'14px'}}>
                                    <Document type={'isin-document'} label='Upload Document'
                                              assoc_id={this.state.formResults.uniqueIdent} placeholder='/bill.jpg' request_id={this.state.formResults.uniqueIdent}
                                              onComplete={this.updateInbound} hideReviewStatus={true}/>
                                    </div>
                                </Toolbar>
                            </AppBar>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Filename</TableCell>
                                    <TableCell>Uploaded At</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(this.state.docIds.length > 0) &&
                                <React.Fragment>
                                    {this.state.docIds.map((v,i)=>{
                                        return (
                                            <TableRow>
                                                <TableCell>{v.orig_filename}</TableCell>
                                                <TableCell style={{textTransform: 'capitalize'}}>{v.createdAt}</TableCell>
                                                <TableCell><Button variant="outlined" color="primary" href={v.system_filename} target={'_blank'}>View</Button></TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </React.Fragment>
                                }
                            </TableBody>
                        </Table>
                        </Paper>
                    </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter((connect(mapStateToProps)(OpenIsin)))));



// WEBPACK FOOTER //
// ./src/main/content/fileRequest/components/openFileRequest.js